import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

const environment  = process.env.REACT_APP_ENV || "production";
const channel = process.env.REACT_APP_CHANNEL || "wordpress";
export const initSentry = () => {
	console.info(`%c initializing sentry env ${environment}`, "color: green");
	Sentry.init({
		dsn: "https://372785d84dd9465ca9baef16c3d2446f@o989497.ingest.sentry.io/5946213",
		integrations: [new Integrations.BrowserTracing()],
		environment,
		beforeSend(e){
			const url = window.location.search;
			if(!url || !url.indexOf("fxl-app-page"))
				return null;
		},

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0
	});
};

/**
 * 
 * @param {*} e - the error
 * @param {*} level - log level to be displayed {"fatal", "error", "warning", "log", "info", "debug", "critical"} 
 * @param {*} user  - { [key: string]: any; id?: string; ip_address?: string; email?: string; username?: string; }
 * @param {*} extra - any object with extra information
 * @param {*} tags  - additional tag object
 */
export const captureException = async (e, level = "info", user, extra = {}, tags = {} ) => {
	
	const onComplete = () => {
		const sentryCaptureContext = {
			level,
			user,
			extra,
			tags: {...tags, channel}
		};
		Sentry.captureException(e, sentryCaptureContext);
	};

	//if user isn't sent try to populate it from indexedDB local storage
	if(!user || !Object.keys(user).length){
		try {
			const indexedDBUser = await getUserFromIndexedDB();
			if (indexedDBUser) {
				user = {
					email: indexedDBUser.email,
					name: indexedDBUser.displayName
				};
			}

		}catch(e){
			console.log(e);
		}finally{
			onComplete();
		}
	}else{
		onComplete();
	}
}


const getUserFromIndexedDB = async () => {
	return new Promise( (resolve,reject) => {

		const FIREBASE_INDEXED_DB = "firebaseLocalStorageDb";
		const FIREBASE_INDEXED_DB_STORE = "firebaseLocalStorage";
		// This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
		const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

		// open or create a database
		const open = indexedDB.open(FIREBASE_INDEXED_DB);

		open.onsuccess = function() {
			// Start a new transaction
			const db = open.result;
			const tx = db.transaction(FIREBASE_INDEXED_DB_STORE, "readonly");
			const store = tx.objectStore(FIREBASE_INDEXED_DB_STORE);
			
			// Query the data
			const data = store.getAll();

			data.onsuccess = function() {
				resolve(data.result[0].value)
			};

			data.onerror = function() {
				reject(data)
			}

			// Close the db when the transaction is done
			tx.oncomplete = function() {
				db.close();
			};
			
		}
	})

}

export default Sentry;